import axios from 'axios'

import { COLLECTION_NAME, TEST_COLLECTION_NAME } from '../../app/constants'

// TODO - use the test nework here
export function RequestUserCollection(user) {
  return axios.request({
    method: 'get',
    // baseURL: `https://wax.api.atomicassets.io/atomicassets/v1/assets?owner=${user}&collection_name=galaktikanft&page=1&limit=1000&order=desc&sort=asset_id`,
    baseURL: `https://test.wax.api.atomicassets.io/atomicassets/v1/assets?owner=${user}&collection_name=${TEST_COLLECTION_NAME}&page=1&limit=1000&order=desc&sort=asset_id&nonce=${Date.now()}`,
  })
}
